import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { FaSpinner } from 'react-icons/fa';
import { withRouter } from 'react-router';

import { loadProductsByKeywords } from '../../../redux/modules/productsSearch';
import connectDataFetchers from '../../shared/lib/connectDataFetchers.js';

import A from '../../shared/Anchor/Anchor';
import LeftFilters from '../../shared/LeftFilters/LeftFilters';
import Breadcrumb from '../../shared/Breadcrumb/Breadcrumb';
import Pager from '../../shared/Pager/Pager';
import ProductThumbnail from '../../shared/ProductThumbnail/ProductThumbnail';

import { primary_dark15, primary_light } from '../../shared/lib/colors';

import '../Categoria/Categoria.scss';
import { css } from '@emotion/core';
import { pushRemarketingEvent } from '../../shared/lib/gaEnhancedEcommerce';
import IubendaCookieSolution from '../../../utils/iubenda';
import { ga4ViewItemList } from '../../shared/lib/ga4EnhancedEcommerce';
import { fkmxViewItemList } from '../../shared/lib/farmakomMetrics';
import { getSHA256Hash } from '../../../utils/sha256';

class Ricerca extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilters: false,
    };
  }

  componentDidMount() {
    if (this.props.hasCriteo) {
      const iubenda = new IubendaCookieSolution(
        this.props.hasIubendaCookieSolution
      );
      iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
    }

    // REMARKETING DINAMICO
    if (this.props.hasDynamicRemarketing) {
      pushRemarketingEvent('searchresults');
    }

    // GA4 TRACK LIST
    if (this.props.hasGoogleAnalytics4Advanced) {
      this.ga4TrackItemsList();
    }

    // FKMX TRACK LIST
    if (this.props.hasFarmakomMetrics) {
      this.fkmxTrackItemsList();
    }
  }

  componentDidUpdate(oldProps, prevProps) {
    if (this.props.loading !== oldProps.loading && !this.props.loading) {
      if (this.props.hasCriteo) {
        const iubenda = new IubendaCookieSolution(
          this.props.hasIubendaCookieSolution
        );
        iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
      }

      // REMARKETING DINAMICO
      if (this.props.hasDynamicRemarketing) {
        pushRemarketingEvent('searchresults');
      }

      // GA4 TRACK LIST
      if (this.props.hasGoogleAnalytics4Advanced) {
        this.ga4TrackItemsList();
      }

      // FKMX TRACK LIST
      if (this.props.hasFarmakomMetrics) {
        this.fkmxTrackItemsList();
      }
    }
  }

  ga4TrackItemsList = () => {
    const { products } = this.props;

    const { keywords } = this.props.params;
    const ga4ListInfo = {
      id: `ricerca_${keywords}`,
      name: `ricerca > ${keywords}`,
    };

    ga4ViewItemList(products, ga4ListInfo);
  };

  fkmxTrackItemsList = () => {
    const { products } = this.props;

    const { keywords } = this.props.params;
    const fkmxListInfo = {
      id: `ricerca_${keywords}`,
      name: `ricerca > ${keywords}`,
    };

    fkmxViewItemList(products, fkmxListInfo);
  };

  renderCriteoTag = () => {
    // <!-- Criteo Category / Search / Listing Tag -->
    const email = (this.props.user && this.props.user.email) || '';
    const zipcode =
      (this.props.user &&
        this.props.user.shipping &&
        this.props.user.shipping.zipcode) ||
      '';
    const productsList = this.props.products.map(prod => `"${prod.id}"`);

    // rimuovo il vecchio tag
    const oldTag = document.getElementById('criteo_listing_tag');
    if (oldTag) {
      document.body.removeChild(oldTag);
    }

    const criteo_listing_tag = document.createElement('script');
    criteo_listing_tag.id = 'criteo_listing_tag';
    criteo_listing_tag.type = 'text/javascript';
    criteo_listing_tag.innerHTML = `
        window.criteo_q = window.criteo_q || [];
        var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
        window.criteo_q.push(
        { event: "setAccount", account: ${this.props.criteoAccountId}},
        { event: "setEmail", email: "${getSHA256Hash(
          email
        )}", hash_method: "sha256" },
        { event: "setZipcode", zipcode: "${zipcode}" },
        { event: "setSiteType", type: deviceType},
        { event: "viewList", item: [${productsList.join(', ')}] });
    `;
    setTimeout(() => {
      document.body.appendChild(criteo_listing_tag);
    }, 200);
    // <!-- END Criteo Category / Search / Listing Tag -->
  };

  toggleFilters = event => {
    event.preventDefault();
    this.setState({
      showFilters: !this.state.showFilters,
    });
  };

  renderProducts(isMobile) {
    return (
      <div style={{ width: '100%' }}>
        {!isMobile && (
          <div className={'desktop'}>{this.renderProductsDesktop()}</div>
        )}
        {isMobile && (
          <div className={'mobile'}>{this.renderProductsMobile()}</div>
        )}
      </div>
    );
  }

  renderProductsDesktop = () => {
    const { keywords } = this.props.params;
    const ga4ListInfo = {
      id: `ricerca_${keywords}`,
      name: `ricerca > ${keywords}`,
    };
    const productsConfiguration = this.props.homePageConfiguration.find(
      item => {
        if (item.moduleType === 'Products_carousel') {
          return item;
        }
        return;
      }
    );
    return (
      <div className={'desktop-container'}>
        {this.props.products.map(product => {
          return (
            <div
              className="col-sm-6 col-lg-4 col-xl-3"
              key={product.id}
              style={{ padding: 0 }}
            >
              <ProductThumbnail
                productsThumbnail={this.props.productsThumbnail}
                productsCarouselVersion={productsConfiguration.moduleVersion}
                primaryColor={this.props.primaryColor}
                secondaryColor={this.props.secondaryColor}
                product={product}
                list="Ricerca"
                ga4ListInfo={ga4ListInfo}
              />
            </div>
          );
        })}
      </div>
    );
  };

  renderProductsMobile = () => {
    const { keywords } = this.props.params;
    const ga4ListInfo = {
      id: `ricerca_${keywords}`,
      name: `ricerca > ${keywords}`,
    };
    const productsConfiguration = this.props.homePageConfiguration.find(
      item => {
        if (item.moduleType === 'Products_carousel') {
          return item;
        }
        return;
      }
    );
    return (
      <div>
        <div className={'mobile-container'}>
          {this.props.products.map((product, index) => {
            return (
              <div style={{ width: '48%' }}>
                <ProductThumbnail
                  key={product.id}
                  productsThumbnail={this.props.productsThumbnail}
                  productsCarouselVersion={productsConfiguration.moduleVersion}
                  primaryColor={this.props.primaryColor}
                  secondaryColor={this.props.secondaryColor}
                  product={product}
                  list="Ricerca"
                  spaceStar={6}
                  ga4ListInfo={ga4ListInfo}
                  lazy={index >= 4}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  render() {
    const { showFilters } = this.state;
    const { category, subcategory, keywords } = this.props.params;
    const {
      location,
      pagination,
      products,
      loading,
      siteName,
      siteUrl,
      logoImage,
      primaryColor,
      secondaryColor,
      uiVariantButton,
    } = this.props;

    return (
      <div className={`categoria ${showFilters ? 'filters-open' : ''}`}>
        <Helmet
          title={`Risultati ricerca per ${keywords}`}
          meta={[
            {
              name: 'description',
              content: `${siteName} - Ecommerce Farmacia vendita ${keywords}`,
            },
            {
              name: 'keywords',
              content: `${keywords}, ecommerce, farmacia, ${siteName}`,
            },
            {
              name: 'robots',
              content: 'index, follow',
            },

            {
              property: 'og:title',
              content: `${siteName} - Ecommerce Farmacia vendita ${keywords}`,
            },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content: `${siteName} - Ecommerce Farmacia vendita online ${keywords}`,
            },
            { property: 'og:image', content: logoImage },
          ]}
          link={[
            {
              rel: 'canonical',
              href: `${siteUrl}/ricerca/${(keywords || '')
                .toLowerCase()
                .replace(/\s+/g, '-')}`,
            },
          ]}
        />

        <div className="container">
          <LeftFilters
            location={location}
            sort={location.query.sort || 'sales'}
          />
          <div className="elenco-prodotti">
            <div className="pre-title">
              <A
                href="#"
                className="filter-toggle desktop"
                onClick={this.toggleFilters}
              >
                {showFilters ? 'Nascondi filtri' : 'Mostra filtri'}
              </A>

              <Breadcrumb page="ricerca" keywords={keywords} />

              {products.length > 0 && pagination.totalPages > 1 && (
                <Pager
                  location={location}
                  page={location.query.page || 1}
                  totalPages={pagination.totalPages}
                  sort={location.query.sort || 'sales'}
                  primaryColor={primaryColor}
                  uiVariantButton={uiVariantButton}
                />
              )}
            </div>

            <div
              className="page-title"
              style={{
                display: 'flex',
                alignItems: 'center',
                color: primary_dark15(primaryColor),
                backgroundColor: primary_light(primaryColor),
                borderRadius: 12,
              }}
            >
              <h1 style={{ fontSize: 20, fontWeight: 600, marginBottom: 0 }}>
                Ricerca di {this.props.params.keywords}
              </h1>
              {loading && (
                <span className="pull-right">
                  <FaSpinner className="pulse" />
                </span>
              )}
            </div>

            {!loading && products.length > 0 && (
              <div>
                <div className="row">
                  {this.renderProducts(this.props.isMobile)}
                </div>

                {pagination.totalPages > 1 && (
                  <Pager
                    location={location}
                    page={location.query.page || 1}
                    totalPages={pagination.totalPages}
                    sort={location.query.sort || 'sales'}
                    primaryColor={primaryColor}
                    isNew
                    uiVariantButton={uiVariantButton}
                  />
                )}
              </div>
            )}

            {!loading && products.length === 0 && (
              <div className="no-results">
                <p>Nessun prodotto soddisfa i criteri di ricerca impostati.</p>
                <p>Prova con un termine più generico.</p>
              </div>
            )}
            <div className="clearfix" />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isMobile: state.layout.isMobile,
    user: state.user.data,
    pagination: state.productsSearch.pagination,
    products: state.productsSearch.data,
    loading: state.productsSearch.loading,
    siteName: state.store.data.datiFarmacia.siteName,
    siteUrl: state.store.data.datiFarmacia.siteUrl,
    logoImage: state.store.data.loghiTemplate.logoImage,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    secondaryColor: state.store.data.loghiTemplate.secondaryColor,
    uiVariantButton: state.store.data.uiVariants.buttons,
    hasCriteo: state.store.data.features.hasCriteo,
    hasDynamicRemarketing: state.store.data.features.hasDynamicRemarketing,
    criteoAccountId: state.store.data.integrazioni.criteo.accountId,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
    homePageConfiguration: state.store.data.home.homePageConfiguration,
    productsThumbnail: state.store.data.home.visualVariants.thumbnailProduct,
  };
}

export default withRouter(
  connect(mapStateToProps)(
    connectDataFetchers(Ricerca, [loadProductsByKeywords])
  )
);

{
  /* <div
    style={{ display: 'flex', gap: 20, flexDirection: 'row-reverse' }}
  >
    <section className="elenco-prodotti" style={{ width: '80%' }}>
      <nav className="pre-title">
        <A
          href="#"
          className="filter-toggle"
          onClick={this.toggleFilters}
        >
          {showFilters ? 'Nascondi filtri' : 'Mostra filtri'}
        </A>

        <Breadcrumb page="ricerca" keywords={keywords} />

        {products.length > 0 && (
          <Pager
            location={location}
            page={location.query.page || 1}
            totalPages={pagination.totalPages}
            sort={location.query.sort || 'sales'}
            primaryColor={primaryColor}
            uiVariantButton={uiVariantButton}
          />
        )}
      </nav>

      <header
        className="page-title"
        style={{
          display: 'flex',
          alignItems: 'center',
          color: primary_dark15(primaryColor),
          backgroundColor: primary_light(primaryColor),
          borderRadius:
            uiVariantButton === '1'
              ? '12px'
              : uiVariantButton === '3'
              ? '30px'
              : 0,
        }}
      >
        <h1 style={{ fontSize: 20, fontWeight: 600, marginBottom: 0 }}>
          Ricerca di {this.props.params.keywords}
        </h1>
        {loading && (
          <span className="pull-right">
            <FaSpinner className="pulse" />
          </span>
        )}
      </header>

      {!loading && products.length > 0 && (
        <div>
          <div className="row">
            {this.renderProducts(true)}
            {this.renderProducts(false)}
          </div>

          <Pager
            location={location}
            page={location.query.page || 1}
            totalPages={pagination.totalPages}
            primaryColor={primaryColor}
            isNew
            uiVariantButton={uiVariantButton}
          />
        </div>
      )}

      {!loading && products.length === 0 && (
        <div className="no-results">
          <p>
            Nessun prodotto soddisfa i criteri di ricerca impostati.
          </p>
          <p>Prova con un termine più generico.</p>
        </div>
      )}
    </section>
    <LeftFilters
      location={location}
      sort={location.query.sort || 'sales'}
    />
  </div> */
}
